import * as React from 'react'
import {
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material'
import { resourceList } from 'shared/constants'

export const ResourceIndexPage = () => {
  resourceList.sort((a, b) => (a.title < b.title ? -1 : 1))
  return (
    <Box>
      <Box>Admin Tools and Resources</Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>URL</TableCell>
            <TableCell>Description</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {resourceList.map((tool) => {
            return (
              <TableRow key={tool.url}>
                <TableCell>{tool.title}</TableCell>
                <TableCell>
                  <a href={tool.url}>{tool.url}</a>
                </TableCell>
                <TableCell>{tool.description}</TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </Box>
  )
}
